// store/modules/globalCache.ts
interface GlobalCacheState {
  /** Supplier 的 options 值 */
  supplierDataList: any[]
  /** Manufacturer 的 options 值 */
  manufacturerDataList: any[]
  /** ManufacturerTypeManufacturerMapList 的 options 值 */
  manufacturerTypeManufacturerMapList: any[]
  /** commentObj 的值 */
  commentObj: any
}

export default {
  state(): GlobalCacheState {
    return {
      supplierDataList: [],
      manufacturerDataList: [],
      manufacturerTypeManufacturerMapList: [],
      commentObj: {}
    }
  },
  mutations: {
    // 统一的数据设置方法
    SET_DATA(state: GlobalCacheState, { key, data }: { key: keyof GlobalCacheState; data: any[] }) {
      state[key] = data
    },
    // 保持原有方法名以兼容现有代码
    SET_SUPPLIER_DATA(state: GlobalCacheState, data: any[]) {
      state.supplierDataList = data
    },
  },
  getters: {
    // 统一的数据获取方法
    getData: (state: GlobalCacheState) => (key: keyof GlobalCacheState) => {
      return state[key]
    },
    // 保持原有方法名以兼容现有代码
    getSupplierDataList(state: GlobalCacheState) {
      return state.supplierDataList
    },
    getManufacturerDataList(state: GlobalCacheState) {
      return state.manufacturerDataList
    }
  }
}